export const ru = {
    FROM_14_TO_28_DAYS: '14—28 дней',
    FROM_1_TO_3_DAYS: '1—3 дней',
    FROM_1_TO_3_MONTHS: 'от 1 до 3 месяцев',
    FROM_3_TO_7_DAYS: '3—7 дней',
    FROM_7_TO_14_DAYS: '7—14 дней',
    MONTHLY: 'ежемесячно',
    MORE_THAN_3_MONTHS: 'больше 3 месяцев'
};
